export default {
  title: 'Member Decoration',
  previewTitle: 'Member Center',
  pageSetting: 'Page Settings',
  pageTitle: 'Page Title',
  pageTitlePlaceholder: 'Please enter page title',
  defaultPageTitle: 'Personal Center',
  modules: 'Modules',
  template: 'Page Template',
  templateType: 'Template Type',
  bgColor: 'Background',
  moduleList: 'Module List',
  moduleConfig: 'Module Config',
  editText: 'Edit Text',
  editTextTitle: 'Edit Text',
  templateGoldBlack: 'Black Gold',
  templateGoldWhite: 'Platinum',
  useDefaultIcon: 'Use Default Icon',
  addNav: 'Add Navigation',
  navNamePlaceholder: 'Please enter navigation name',
  navLinkPlaceholder: 'Please enter target link',
  memberCenterLink: 'Member Center Link',
  copyLinkTitle: 'Copy Link',
  copyAddress: 'Copy Address',
  copy: 'Copy',
  copySuccess: 'Copied successfully',
  scanToPreview: 'Scan to preview',
  linkTipH5: 'This link is for H5 environment',
  syncConfig: 'Sync Config',
  syncConfigTitle: 'Sync Configuration',
  syncConfigDesc: 'Sync the configuration of the current language ({lang}) to:',
  syncConfigSuccess: 'Sync successful',
  moduleNames: {
    MemberInfo: 'Member Info',
    NavBar: 'Navigation',
    PointsRedPacket: 'Points & Red Packet',
    TabBar: 'Tab Bar',
  },
  labelName: {
    levelName: 'Diamond Member',
    progressLabel: 'Distance to upgrade',
    progressUnit: 'growth points',
    benefitsText: 'Member Benefits',
    pointsTitle: 'My Points',
    pointsRule: 'Exchange Rules',
    pointsExchange: 'Points Exchange',
    redpacketTitle: 'My Red Packet',
    redpacketRule: 'Exchange Rules',
    redpacketExchange: 'Red Packet Exchange',
  },
  formLabel: {
    memberLevel: 'Member Level',
    memberBenefits: 'Member Benefits',
    pointsModule: 'Points Module',
    points: 'Points',
    rule: 'Rule',
    pointsExchange: 'Points Exchange',
    redpacketModule: 'Red Packet Module',
    redpacket: 'Red Packet',
    redpacketExchange: 'Red Packet Exchange',
  },
};